import { useState } from 'react'
import { useAuthSession } from './AuthSessionContext'
import { PartnerInviteEntry } from '../components/PartnerInviteEntry'

export function SignInScreen() {
  const { mode, signIn } = useAuthSession()
  const [email, setEmail] = useState(mode === 'prototype' ? 'owner@pmm.local' : '')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [busy, setBusy] = useState(false)
  const partnerInviteToken = new URLSearchParams(window.location.search).get('partner-invite')?.trim() ?? ''

  async function enter(role: 'owner' | 'client' = 'owner') {
    setBusy(true)
    setError('')
    try {
      await signIn(email, password, role)
    } catch {
      setError('Sign-in was not accepted. Check the account and try again.')
    } finally {
      setBusy(false)
    }
  }

  if (partnerInviteToken) return <PartnerInviteEntry token={partnerInviteToken} />
  return (
    <main className="signin-shell">
      <section className="signin-card" aria-labelledby="signin-title">
        <div className="signin-brand"><span>PM</span><p>Primal<br /><strong>Masculine Man</strong></p></div>
        <p className="eyebrow">Private personal alpha</p>
        <h1 id="signin-title">A protected space for the man you practise becoming.</h1>
        <p>Your relationship data belongs behind an authenticated session. Coach access is a separate server-issued capability.</p>
        <label><span>Email</span><input type="email" autoComplete="username" value={email} onChange={(event) => setEmail(event.target.value)} /></label>
        {mode === 'firebase' && <label><span>Password</span><input type="password" autoComplete="current-password" value={password} onChange={(event) => setPassword(event.target.value)} /></label>}
        {error && <p className="auth-error" role="alert">{error}</p>}
        {mode === 'prototype' ? (
          <div className="prototype-entry-actions">
            <button type="button" disabled={busy} onClick={() => void enter('owner')}>Enter owner trial</button>
            <button type="button" className="secondary-action" disabled={busy} onClick={() => void enter('client')}>Preview client access</button>
          </div>
        ) : <button type="button" disabled={busy || !email || !password} onClick={() => void enter()}>{busy ? 'Signing in...' : 'Sign in securely'}</button>}
        <div className="collection-notice"><strong>Before you enter</strong><p>Session authentication is stored for this browser session only. No advertising trackers are used. You control optional AI, reflection, notification and device consent separately.</p></div>
        {mode === 'prototype' && <p className="prototype-mode-note">Prototype access uses simulated identities and memory-only data. It cannot grant Firebase permissions.</p>}
      </section>
    </main>
  )
}
